import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";
import { withStyleProps } from "Utils/styleProps";

type bodyTextWeight = "normal" | "bold";
type Props = {
  /**
  @ignore
  * */
  className?: string;
  size: "small" | "medium" | "large" | "x-large" | "ns-twelve" | "ns-twenty" | "ns-sixteen";

  /**
  @ignore
  * */
  componentClass: React.ElementType;
  italic: boolean;
  muted: boolean;
  disabled: boolean;
  error: boolean;
  uppercase: boolean;
  agent: boolean;
  blue: boolean;
  white: boolean;
  currentColor?: boolean;
  weight?: bodyTextWeight | null | undefined;

  /**
  @ignore
  * */
  children?: React.ReactNode;
};

let BodyText = (props: Partial<Props>) => {
  const {
    size = "medium",
    componentClass = "div",
    italic = false,
    uppercase = false,
    agent = false,
    muted = false,
    disabled = false,
    error = false,
    blue = false,
    white = false,
    currentColor = false,
    color,
    weight,
    children,
    className,
    ...rest
  } = props;
  const legacyColorProps = {
    muted,
    disabled,
    error,
    white,
    currentColor,
  };
  const colorIndex = Object.values(legacyColorProps).lastIndexOf(true);
  const colorFallback = colorIndex > -1 ? Object.keys(legacyColorProps)[colorIndex] : null;
  const finalColor = color || colorFallback;
  const component = componentClass;
  const classes = classnames("BodyText", `BodyText--${size}`, className, {
    [`BodyText--${weight}`]: weight,
    "BodyText--italic": italic,
    "BodyText--uppercase": uppercase,
    "BodyText--agent": agent,
    [`BodyText--${finalColor}`]: !blue && finalColor,
  });
  return React.createElement(
    component,
    {
      className: classes,
      ...rest,
    },
    children,
  );
};

BodyText.propTypes = {
  // prefix 'ns-' means size is non-standard, and shouldn't be used for new elements
  size: PropTypes.oneOf(["small", "medium", "large", "x-large", "ns-twelve", "ns-twenty", "ns-sixteen"]),
  italic: PropTypes.bool,
  uppercase: PropTypes.bool,
  agent: PropTypes.bool,
  blue: PropTypes.bool,
  muted: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  white: PropTypes.bool,
};
BodyText = withStyleProps(BodyText);
export default BodyText;
